import { getTerminalMode, terminalUserLogout } from 'utils/terminal';

export const kioskSetup = (idleTimeInMiliseconds = 180000) => {
  localStorage.setItem('currency', 'AED');
  const idleLogout = () => {
    let timer: NodeJS.Timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        terminalUserLogout();
      }, idleTimeInMiliseconds);
    };

    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.ontouchmove = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener('scroll', resetTimer, true);
  };

  if (getTerminalMode()) {
    idleLogout();
  }
};
